import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'

import './index.scss'

import { TextProvider } from './contexts/text'
import { FilesProvider } from './contexts/files'

ReactDOM.render(
    <TextProvider>
        <FilesProvider>
            <App />
        </FilesProvider>
    </TextProvider>,
    document.getElementById('root')
)